import { useNavigate } from "react-router-dom";

const validateVendorLogin = () => {
    const email = localStorage.getItem('email');
    const id = localStorage.getItem('id');
    const token = localStorage.getItem('tcn');
    const username = localStorage.getItem('username');

    // Check if any key is empty
    if (!email || !id || !token || !username) {
        return false;
    }
    else {
        const lastCallTime = localStorage.getItem('lastValidationTime');
        const currentTime = Date.now();
        const thirtyMinutesInMs = 30 * 60 * 1000;

        if (lastCallTime && (currentTime - parseInt(lastCallTime)) > thirtyMinutesInMs) {
            return false;
        }

        localStorage.setItem('lastValidationTime', currentTime.toString());
    }

    return true;
};

const clearLocalStorage = () => {
    localStorage.removeItem('email');
    localStorage.removeItem('id');
    localStorage.removeItem('tcn');
    localStorage.removeItem('username');
    localStorage.removeItem('lastValidationTime');
    localStorage.removeItem('SZTypeList');
};

const useClearLocalStorageAndRedirect = () => {
    const navigate = useNavigate();

    const clearLocalStorageAndRedirect = () => {
        clearLocalStorage();
        if (typeof document !== 'undefined') {
            document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
            const body = document.body;
            body.classList.remove('modal-open');
            body.style.removeProperty('overflow');
            body.style.removeProperty('padding-right');
        }
        setTimeout(() => {
            window.location.reload();
        }, 300);

        navigate('/');
    };

    return clearLocalStorageAndRedirect;
};

// New function to validate token and id, clear storage and redirect if invalid
const validateAuthAndRedirect = (navigate) => {
    let Token = null;
    let vendorid = null;

    try {
        // Get and parse token
        const tokenStr = localStorage.getItem('tcn');
        Token = tokenStr ? JSON.parse(tokenStr) : null;
    } catch (e) {
        console.error("Error parsing token:", e);
        Token = localStorage.getItem('tcn'); // Fallback to raw token
    }

    // Get vendor id
    const id = localStorage.getItem("id");
    vendorid = id ? parseInt(id, 10) : 0;

    // Validate: if token is invalid or id is 0, clear and redirect
    if (!Token || vendorid === 0) {
        clearLocalStorage();
        if (navigate) {
            navigate('/');
        } else {
            window.location.href = '/';
        }
        return { isValid: false, Token: null, vendorid: 0 };
    }

    return { isValid: true, Token, vendorid };
};

// Hook version for use in React components
const useValidateAuth = () => {
    const navigate = useNavigate();

    const validateAuth = () => {
        return validateAuthAndRedirect(navigate);
    };

    return validateAuth;
};

export {
    validateVendorLogin,
    clearLocalStorage,
    useClearLocalStorageAndRedirect,
    validateAuthAndRedirect,
    useValidateAuth
};